/**
 * Created by sy on 2018/9/18.
 */
import fetch from "../api/fetch";

fetch.install = function (Vue) {
  Vue.prototype.$axios = fetch;
};

export default fetch;
